export default {
  "b2b.rezervace-vytvoreni.obdobi.label": "Období",
  "b2b.rezervace-vytvoreni.datumOd.label": "Datum",
  "b2b.rezervace-vytvoreni.doplnkove-sluzby.label": "Doplňkové služby",
  "b2b.rezervace-vytvoreni.poznamka.label": "Poznámka",
  "b2b.rezervace-vytvoreni.fixni-naroky.label":
    "Fixní nároky pro zvolené období a zdroj",
  "b2b.rezervace-vytvoreni.fixni-naroky.text":
    "Zadané: {zadane} | Povolené: {povolene}",
  "b2b.rezervace-vytvoreni.save-dialog.title": "Odeslání žádosti",
  "b2b.rezervace-vytvoreni.submit": "Odeslat rezervaci",
  "b2b.rezervace-vytvoreni.rychla-widget.title": "Rychlá žádost o rezervaci",
  "b2b.rezervace-vytvoreni.rychla-widget.submit": "Vytvořit rezervaci"
};
